module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Besvar fraværsanmodning")]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(_vm.request.vUserName) + ":")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vSubjectTitle) + ",")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vStart) + " -")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vEnd))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-top": "1px solid #e2e8f0"
    }
  }, [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.request.request_note))])])])]), _vm._v(" "), _c('div', {
    staticClass: "marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Note til besvarelsen")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "do-input do-textarea",
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__flex"
  }, [_c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isLoadingRejected
    },
    on: {
      "click": _vm.rejectRequest
    }
  }, [_vm._v("\n        Afvis\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isLoadingApprove
    },
    on: {
      "click": _vm.approveRequest
    }
  }, [_vm._v("\n        Godkend\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-505775f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestListAnswer.vue
// module id = 1637
// module chunks = 1